import { Observable, of } from 'rxjs';
import { catchError, debounceTime, map, tap } from 'rxjs/operators';
import { IAvailableTypes, IConstantItem } from 'src/app/core/models/available-types.interface';
import { ICountry, IState } from 'src/app/core/models/country.interface';
import { CityService } from 'src/app/core/services/city.service';
import { CompanyMarketplaceService } from 'src/app/core/services/company-marketplaces.service';
import { ConstantService } from 'src/app/core/services/constant.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { UserService } from 'src/app/core/services/user.service';
import {
    RegistrationService
} from 'src/app/modules/customer-registration/services/registration.service';
import { CityType } from 'src/app/shared/enums/city-type.enum';
import { PlaceStatus } from 'src/app/shared/enums/place-status.enum';
import { AddCityPopup } from 'src/app/shared/popups/add-city-popup/add-city-popup.component';
import { ConfirmPopupDialog } from 'src/app/shared/popups/confirm-popup/confirm-popup.component';

import { DatePipe } from '@angular/common';
import {
    Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges
} from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { IPaginatorProperties } from '../../../../../core/models/paginator.interface';
import { BuyerType } from '../../../../../shared/enums/buyer-type.enum';
import { B2bclientsAccessPopupComponent } from '../../../../b2bclients/components/dialogs/b2bclients-access-popup/b2bclients-access-popup.component';
import { b2bclientsService } from '../../../../b2bclients/services/b2bclients.service';
import { ICarrierItem } from '../../../../shipment-price/models/shipment-price.interface';
import { ShipmentPriceService } from '../../../../shipment-price/services/shipment-price.service';
import { ISaleOrder } from '../../../models/sale-order.interface';
import {
    IStatusType,
    ISaleOrderStatusHistoryRow,
    SaleOrderStatusCategory,
} from '../../../models/status-type.interface';
import { ISaleOrderRemark } from '../../../models/sale-order-remark.interface';
import { SaleOrderService } from '../../../services/sale-order.service';
import { cellPhoneValidatorNew, emailValidator } from 'src/app/core/helpers/helpers.function';
import { formConstant } from 'src/config';
import { isDeliveredSaleOrderStatus, isDeliveredSaleOrderStatusName } from 'src/app/core/constants.enum';
import { SaleOrderStatus } from 'src/app/shared/enums/sale-order-status.enum';
import { DeliveryStatusLabelPipe } from 'src/app/shared/pipes/delivery-status-label.pipe';
import { AddRemarkPopup } from 'src/app/shared/popups/add-remark-popup/add-remark-popup.component';
import { Roles } from 'src/app/shared/enums/role-types.enum';
import { CompanyType } from 'src/app/shared/enums/company-type.enum';
import {
    getGrossAmountDisplayValues,
    isFullFinancialRefundOrder,
} from '../../../utils/sale-order-list-net-amounts.util';

@Component({
    selector: 'eci-main-details',
    templateUrl: './main-details.component.html',
    styleUrls: ['./main-details.component.scss']
})
export class MainDetailsComponent implements OnInit, OnChanges {

    @Input() info: ISaleOrder;
    @Input() isCreateMode: boolean = true;
    @Input() isB2BSaleOrder: boolean = false;
    @Input() isMarketplaceSO: boolean = false;
    @Input() creationType: string = 'single';
    @Input() availableTypes: IAvailableTypes;
    @Input() hasError: boolean;
    // @Input() availableStates: string[]; // Commented because we are not using it anymore to fetch the next state of sale order. Keeping it in case we need it in the future.
    @Input() buyers: any[] = [];
    @Input() availableCarriers: ICarrierItem[] = [];
    @Input() showErrors: boolean;
    @Input() isReorderAvailable: any;
    @Input() disableB2BShipment: boolean = false;
    @Input() hideMarketplaceAndDeliverySections: boolean = false;

    @Output() infoChange = new EventEmitter<ISaleOrder>();
    @Output() hasErrorChange = new EventEmitter<boolean>();
    @Output() getOrder = new EventEmitter<number>();
    @Output() clickReorder = new EventEmitter<any>();
    @Output() selectedShopChange = new EventEmitter<any>();
    @Output() selectedOriginCountry = new EventEmitter<any>();

    public form: FormGroup;

    countries: ICountry[];
    allCountries: ICountry[];
    buyerStates: IState[];
    billingStates: IState[];
    shippingStates: IState[];
    companyList: any[] = [];
    shippingCities: any[] = [];
    billingCities: any[] = [];
    showLoader: boolean = false;
    marketplaceList: any[];
    BuyerType = BuyerType;
    inputType: any;
    formConstant = formConstant;
    searchCountry: FormControl = new FormControl('');
    searchState: FormControl = new FormControl('');
    searchShipmentCountry: FormControl = new FormControl('');
    searchShipmentState: FormControl = new FormControl('');
    searchCustomerName: FormControl = new FormControl('');
    searchmarketplaceName: FormControl = new FormControl('');
    searchbuyerType: FormControl = new FormControl('');
    searchShipmentCity: FormControl = new FormControl('');
    searchBillingCity: FormControl = new FormControl('');
    searchOriginCountry: FormControl = new FormControl('');
    searchCarrier: FormControl = new FormControl('');
    searchBuyerName: FormControl = new FormControl('');
    searchOperationalStatus: FormControl = new FormControl('');
    searchFinancialStatus: FormControl = new FormControl('');
    newBuyerName: FormControl = new FormControl('');
    buyerName: FormControl = new FormControl('');
    InputType: string;
    isStatusRemark: string = '';
    saleOrderRemarks: ISaleOrderRemark[] = [];
    remarksLoading = false;
    operationalStatusOptions: IStatusType[] = [];
    financialStatusOptions: IStatusType[] = [];
    saleOrderStatusHistories: ISaleOrderStatusHistoryRow[] = [];
    currentOperationalStatusId: number | null = null;
    currentFinancialStatusId: number | null = null;
    currentOperationalHistoryId: number | null = null;
    currentFinancialHistoryId: number | null = null;
    statusHistoriesLoaded = false;
    private suppressStatusChange = false;
    orderCurrency: string;
    currentOrderStatus: any;
    PlaceStatus = PlaceStatus;
    CityType = CityType;
    countriesData: ICountry[];
    previousCarriersPage: number = 0;
    totalCarriersPage: number = 0;
    selectedBuyer;
    telOptions = { separateDialCode: true, autoHideDialCode: false };
    buyerPhoneObj;
    phoneObj;
    shouldUpdateState: boolean = true;
    shippingPhoneNumberRequired = false;

    constructor(
        public userSvc: UserService,
        private formBuilder: FormBuilder,
        private constSvc: ConstantService,
        private regSvc: RegistrationService,
        private datePipe: DatePipe,
        private saleOrderSvc: SaleOrderService,
        private companyMarketplaceSvc: CompanyMarketplaceService,
        private citySvc: CityService,
        private notify: NotificationService,
        private dialog: MatDialog,
        private carriersSvc: ShipmentPriceService,
        private b2bclientsService: b2bclientsService,
        private deliveryStatusLabelPipe: DeliveryStatusLabelPipe,
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['showErrors']) {
            if (this.showErrors) this.form?.markAllAsTouched();
        }
        if (changes['info']) {
            if (this.info && this.form) {
                this.form.controls.shipmentTrackingNumber.setValue(this.info.shipmentTrackingNumber);
                this.form.controls.referenceOrderId.setValue(this.info?.marketplace?.referenceOrderId);
                this.form.controls.marketplaceOrderID.setValue(this.info?.marketplace?.marketplaceOrderId);
                this.form.controls.carrierCompany.setValue(this.info?.carrierCompany);

                if (this.allCountries) {
                    const countryOfOriginCode = this.allCountries?.find((el) =>
                        el?.code === this.info?.countryOfOriginCode ||
                        el?.codeFull === this.info?.countryOfOriginCode
                    );
                    this.form.get('countryOfOriginCode').setValue(countryOfOriginCode?.codeFull);
                } else {
                    this.form.get('countryOfOriginCode').setValue(this.info?.countryOfOriginCode);
                }

                this.checkEciTotal(changes['info']);
                this.loadSaleOrderStatusDropdowns();
                this.loadSaleOrderRemarks();
                this.patchAmountDisplayFields();
            }
        }
    }

    /** Display-only: show debit gross amounts on order details (refunds shown separately on Refunds tab). */
    private patchAmountDisplayFields(): void {
        if (!this.form || this.isCreateMode || !this.info) {
            return;
        }
        const amounts = getGrossAmountDisplayValues(this.info);
        this.form.controls.sellOrderTotal?.setValue(amounts.sellOrderTotal);
        this.form.controls.eciVat?.setValue(amounts.eciVat);
        this.form.controls.sellOrderAmount?.setValue(amounts.sellOrderAmount);
        this.form.controls.eciVatEuro?.setValue(amounts.eciVatEuro);
        this.form.controls.eciTotalEuro?.setValue(amounts.eciTotalEuro);
        this.form.controls.theoreticalVat?.setValue(amounts.theoreticalVat);
    }

    private resolveAmountDisplayValues(info: ISaleOrder): {
        sellOrderTotal: string;
        eciVat: string;
        sellOrderAmount: string;
        eciVatEuro: string;
        eciTotalEuro: string;
        theoreticalVat: string;
    } {
        return getGrossAmountDisplayValues(info);
    }

    get customerInformation(): string {
        return this.isMarketplaceSO ? 'Seller Information' : 'Empact Customer Information';
    }

    get marketplaceTitle(): string {
        return this.isMarketplaceSO ? 'Empact Order Details' : 'Marketplace Order Details';
    }

    get availableBuyerType(): IConstantItem[] {
        if (!this.availableTypes) return;
        if (!this.info?.isB2B) {
            const forB2C = this.availableTypes.SellBuyerType.filter((item) => item.id != BuyerType.Business)
            return forB2C;
        } else {
            const forB2B = this.availableTypes.SellBuyerType.filter((item) => item.id == BuyerType.Business)
            this.form.get('buyerType').setValue(BuyerType.Business)
            return forB2B;
        }
    }

    get orderStatuses(): IConstantItem[] {
        if (!this.availableTypes) {
            return;
        }

        if (this.userSvc.isIndVat || this.info?.company?.type === CompanyType['Reporting tool']) {
            return this.availableTypes.SaleOrderStatus.filter(el => el.id !== SaleOrderStatus.CANCELED &&
                el.id !== SaleOrderStatus.EARLY_CANCELATION);
        }

        return this.availableTypes.SaleOrderStatus;
    }

    ngOnInit(): void {
        this.form = this.initializeForm(this.info);
        this.getAllCountries();
        this.isStatusRemark = this.info?.statusRemark;
        if (!this.isCreateMode && (!this.info?.shipmentTrackingNumber || !this.info?.carrierCompany)) {
            this.confirmDialog();
        }
        this.subscribeOnFieldChanges();
        this.subscribeOnAvailaableTypes();
        this.isB2b();
        if (this.isCreateMode) {
            this.getCompanyList();
        }

        if (this.info?.id) {
            if (this.info.company?.users && this.info.company?.users[0]?.partner == 'JD') {
                this.shippingPhoneNumberRequired = true;
            } else {
                this.shippingPhoneNumberRequired = false;
            }
            this.loadSaleOrderRemarks();
        }

        this.form.get('billingCountry').setValue(this.info?.marketplace?.buyer?.billingAddress?.state?.country?.code);
        this.form.get('shippingCountry').setValue(this.info?.marketplace?.buyer?.shippingAddress?.state?.country?.code);

        this.setOriginCountry();

        this.form.controls.buyerType?.valueChanges.subscribe(value => {
            if (value === BuyerType.Business) {
                this.form?.controls['vatNumber']?.setValidators([Validators.required, Validators.pattern('^[0-9a-zA-Z]{8,15}$')]);
                this.form?.controls['vatNumber']?.updateValueAndValidity();
            } else {
                this.updateValidator(value === BuyerType.Business, 'vatNumber');
            }
        });
        this.form.controls.shipmentTrackingNumber?.valueChanges.subscribe((value) => {
            this.updateValidator(!!this.form.controls.carrierCompany.value && !!this.form.controls.shipmentTrackingNumber.value, 'shippingDate');
        });
        this.form.controls.carrierCompany?.valueChanges.subscribe((value) => {
            this.updateValidator(!!this.form.controls.carrierCompany.value && !!this.form.controls.shipmentTrackingNumber.value, 'shippingDate');
        });
        this.buyerName.valueChanges.subscribe(value => {
            this.selectedBuyer = value;
            if (this.selectedBuyer) {
                if (this.selectedBuyer.id) {
                    this.form.get('buyerID').setValue(this.selectedBuyer.id);
                    this.form.get('buyerName').setValue(`${this.selectedBuyer?.firstName || ''} ${this.selectedBuyer?.lastName || ''}`);
                    this.form.get('buyerEmail').setValue(this.selectedBuyer.email);
                    this.form.get('buyerPhoneNumber').setValue(this.selectedBuyer.mobileNumber);
                    this.form.get('vatNumber').setValue(this.selectedBuyer.vatNumber);
                    this.form.get('billingAddrees').setValue(this.selectedBuyer?.address?.name);
                    this.form.get('billingZipCode').setValue(this.selectedBuyer.address.zipCode);

                    const buyerCountryIso2 = this.getIso2Code(this.selectedBuyer.phoneCode);
                    this.buyerPhoneObj.setCountry(buyerCountryIso2);

                    const country = this.allCountries.find(c => c.id === this.selectedBuyer.address.countryId);
                    if (country) {
                        this.form.get('billingCountry').setValue(country.code);
                    }
                } else {
                    this.form.get('buyerName').setValue(`${this.selectedBuyer?.firstName || ''} ${this.selectedBuyer?.lastName || ''}`);
                }
            }
        });

        this.getAvailableCarriers();
        if (this.isCreateMode) {
            this.subscribeShippingPhoneNumber();
        }
        this.searchCarrier.valueChanges.pipe(debounceTime(500)).subscribe(value => {
            this.previousCarriersPage = 0;
            this.getAvailableCarriers();
        });

        if (this.isCreateMode) {
            this.orderCurrency = 'EUR';
            this.form.valueChanges.subscribe(_ => {
                this.info = this.model;
                this.infoChange.emit(this.info);
                this.hasErrorChange.emit(!this.form.valid);
            });
            this.subscribeOnAvailableMarketplaces(this.userSvc.company?.id);
        }

        if (this.userSvc.isAdmin) {
            if (this.info?.companyId) {
                this.getAvailableBuyers(this.info?.companyId);
            }
            this.form.controls.sellerName.valueChanges.subscribe((value) => {
                this.subscribeOnAvailableMarketplaces(value);
                this.getAvailableBuyers(value);
            });
        } else {
            this.getAvailableBuyers(this.userSvc.company?.id);
        }
        if (this.isMarketplaceSO) {
            this.form.controls.phoneNumber.setValidators(Validators.required);
            this.form.controls.email.setValidators(Validators.required);
            this.form.controls?.invoiceNumber.clearValidators();
            this.form.controls?.marketplaceOrderID.clearValidators();

            this.form.get('buyerType').setValue(BuyerType.Business);
        }

        this.form.controls.marketplaceName.valueChanges.subscribe(value => {
            this.selectedShopChange.emit(this.marketplaceList.find(el => el.id === value));
        })

        this.subscribeOnAvailableMarketplaces(this.info?.companyId);

        if (!this.isCreateMode) {
            const countryIso2 = this.getIso2Code(this.info?.marketplace?.buyer?.phoneCountryCode);
            this.phoneObj?.setCountry(countryIso2);
            const apiBuyerPhoneCountry = this.info?.marketplace?.buyer?.buyerPhoneCountryCode;
            const buyerPhoneCountryMissing =
                apiBuyerPhoneCountry == null || String(apiBuyerPhoneCountry).trim() === '';
            const buyerCountryIso2 =
                !this.isMarketplaceSO && buyerPhoneCountryMissing
                    ? this.getBillingCountryIso2Lower() || 'us'
                    : this.getIso2Code(apiBuyerPhoneCountry);
            this.form.get('buyerPhoneCountryCodeIso2').setValue(buyerCountryIso2);
        }

        if (!this.info?.id) {
            setTimeout(() => {
                this.phoneObj.setCountry('us');
                this.buyerPhoneObj.setCountry('us');
            }, 1000);
        }

        if (!this.isCreateMode && this.info?.id) {
            this.loadSaleOrderStatusDropdowns();
        }
    }

    private loadSaleOrderStatusDropdowns(): void {
        if (!this.info?.id || !this.form || this.isCreateMode || this.hideMarketplaceAndDeliverySections) {
            return;
        }

        this.statusHistoriesLoaded = false;

        this.saleOrderSvc.getStatusTypes().subscribe((statusTypes: IStatusType[]) => {
            this.operationalStatusOptions = this.mapStatusOptionsForSearch(
                (statusTypes || []).filter((row) => row.statusType === SaleOrderStatusCategory.OPERATIONAL),
            );
            this.financialStatusOptions = this.mapStatusOptionsForSearch(
                (statusTypes || []).filter((row) => row.statusType === SaleOrderStatusCategory.FINANCIAL),
            );

            this.refreshStatusHistories().subscribe({
                next: () => this.applyLatestStatusSelections(),
                error: () => {
                    this.saleOrderStatusHistories = [];
                    this.statusHistoriesLoaded = true;
                    this.applyLatestStatusSelections();
                },
            });
        });
    }

    private refreshStatusHistories(): Observable<ISaleOrderStatusHistoryRow[]> {
        if (!this.info?.id) {
            this.saleOrderStatusHistories = [];
            this.statusHistoriesLoaded = true;
            return of([]);
        }

        return this.saleOrderSvc.getSaleOrderStatusHistories(this.info.id).pipe(
            map((response) => this.normalizeStatusHistories(response)),
            tap((histories) => {
                this.saleOrderStatusHistories = histories;
                this.statusHistoriesLoaded = true;
            }),
            catchError(() => {
                this.statusHistoriesLoaded = true;
                this.saleOrderStatusHistories = [];
                return of([]);
            }),
        );
    }

    private normalizeStatusHistories(response: any): ISaleOrderStatusHistoryRow[] {
        if (Array.isArray(response)) {
            return response;
        }
        if (Array.isArray(response?.data)) {
            return response.data;
        }
        return [];
    }

    private static readonly SYSTEM_STATUS_REASON = 'status added by status update api';

    /** Prefer history statusReason; hide system default; fall back to legacy order statusRemark. */
    private resolveDisplayStatusRemark(statusReason?: string | null): string {
        const fromHistory = (statusReason || '').trim();
        if (fromHistory && fromHistory !== MainDetailsComponent.SYSTEM_STATUS_REASON) {
            return fromHistory;
        }
        return (this.info?.statusRemark || '').trim();
    }

    private applyLatestStatusSelections(): void {
        const latestOperationalRow = this.findLatestHistoryRowByCategory(
            this.saleOrderStatusHistories,
            SaleOrderStatusCategory.OPERATIONAL,
        );
        const latestFinancialRow = this.findLatestHistoryRowByCategory(
            this.saleOrderStatusHistories,
            SaleOrderStatusCategory.FINANCIAL,
        );

        this.suppressStatusChange = true;
        if (latestOperationalRow?.empactStatusId != null) {
            this.form.controls.operationalStatus.setValue(latestOperationalRow.empactStatusId, { emitEvent: false });
            this.currentOperationalStatusId = latestOperationalRow.empactStatusId;
            this.currentOperationalHistoryId = latestOperationalRow.id ?? null;
        }
        if (latestFinancialRow?.empactStatusId != null) {
            this.form.controls.financialStatus.setValue(latestFinancialRow.empactStatusId, { emitEvent: false });
            this.currentFinancialStatusId = latestFinancialRow.empactStatusId;
            this.currentFinancialHistoryId = latestFinancialRow.id ?? null;
        }
        this.isStatusRemark = this.resolveDisplayStatusRemark(
            latestOperationalRow?.statusReason ?? (latestOperationalRow as any)?.status_reason,
        );
        this.suppressStatusChange = false;
        this.syncCurrencyEditability();
    }

    onOperationalStatusChange(event: MatSelectChange): void {
        this.onStatusCategoryChange(
            event.value,
            this.currentOperationalStatusId,
            SaleOrderStatusCategory.OPERATIONAL,
            'operationalStatus',
        );
    }

    onFinancialStatusChange(event: MatSelectChange): void {
        this.onStatusCategoryChange(
            event.value,
            this.currentFinancialStatusId,
            SaleOrderStatusCategory.FINANCIAL,
            'financialStatus',
        );
    }

    private onStatusCategoryChange(
        newStatusId: number,
        previousStatusId: number | null,
        category: SaleOrderStatusCategory,
        formControlName: 'operationalStatus' | 'financialStatus',
    ): void {
        if (this.suppressStatusChange || !this.userSvc.isAdmin || this.userSvc.isDelicated) {
            return;
        }

        if (newStatusId === previousStatusId) {
            return;
        }

        this.form.controls[formControlName].setValue(previousStatusId, { emitEvent: false });

        this.refreshStatusHistories().subscribe({
            next: () => {
                const anchorHistoryId = this.getStatusHistoryAnchorId(category);
                this.openStatusChangeReasonDialog(
                    anchorHistoryId,
                    newStatusId,
                    previousStatusId,
                    category,
                    formControlName,
                );
            },
            error: (err) => {
                this.notify.showError(err?.error?.error || err?.error?.message || 'Failed to load status history');
            },
        });
    }

    private openStatusChangeReasonDialog(
        anchorHistoryId: number | null,
        newStatusId: number,
        previousStatusId: number | null,
        category: SaleOrderStatusCategory,
        formControlName: 'operationalStatus' | 'financialStatus',
    ): void {
        const dialogRef = this.dialog.open(AddRemarkPopup);
        dialogRef.componentInstance.remarkOptional = true;
        dialogRef.componentInstance.dialogTitle = 'Status change reason';

        dialogRef.afterClosed().subscribe((reason) => {
            if (reason === undefined) {
                return;
            }

            const payload: {
                status_Id?: number;
                saleOrderId: number;
                newStatusId: number;
                status_reason?: string;
            } = {
                saleOrderId: Number(this.info.id),
                newStatusId: Number(newStatusId),
                status_reason: reason || undefined,
            };

            if (anchorHistoryId != null) {
                payload.status_Id = Number(anchorHistoryId);
            }

            this.showLoader = true;
            this.saleOrderSvc.appendAdminStatusHistory(payload).subscribe(
                () => {
                    this.notify.showSuccessMessage('Status updated successfully');
                    this.showLoader = false;
                    if (category === SaleOrderStatusCategory.OPERATIONAL) {
                        this.currentOperationalStatusId = newStatusId;
                        this.isStatusRemark = this.resolveDisplayStatusRemark(reason);
                    } else {
                        this.currentFinancialStatusId = newStatusId;
                    }
                    this.syncCurrencyEditability();
                    this.form.controls[formControlName].setValue(newStatusId, { emitEvent: false });
                    this.loadSaleOrderStatusDropdowns();
                    this.getOrder.emit(this.info.id);
                },
                (err) => {
                    this.showLoader = false;
                    this.form.controls[formControlName].setValue(previousStatusId, { emitEvent: false });
                    this.notify.showError(err?.error?.error || err?.error?.message || 'Failed to update status');
                },
            );
        });
    }

    private getStatusHistoryAnchorId(category: SaleOrderStatusCategory): number | null {
        if (category === SaleOrderStatusCategory.OPERATIONAL && this.currentOperationalHistoryId) {
            return this.currentOperationalHistoryId;
        }
        if (category === SaleOrderStatusCategory.FINANCIAL && this.currentFinancialHistoryId) {
            return this.currentFinancialHistoryId;
        }

        const categoryRow = this.findLatestHistoryRowByCategory(this.saleOrderStatusHistories, category);
        if (categoryRow?.id) {
            return categoryRow.id;
        }

        return this.saleOrderStatusHistories[0]?.id ?? null;
    }

    private findLatestHistoryRowByCategory(
        histories: ISaleOrderStatusHistoryRow[],
        category: SaleOrderStatusCategory,
    ): ISaleOrderStatusHistoryRow | null {
        if (!histories?.length) {
            return null;
        }

        let latest: ISaleOrderStatusHistoryRow | null = null;
        for (const row of histories) {
            if (this.resolveHistoryRowCategory(row) !== category) {
                continue;
            }
            if (!latest || this.isHistoryRowNewer(row, latest)) {
                latest = row;
            }
        }
        return latest;
    }

    private isHistoryRowNewer(
        candidate: ISaleOrderStatusHistoryRow,
        current: ISaleOrderStatusHistoryRow,
    ): boolean {
        const candidateTime = new Date(candidate.statusDate || 0).getTime();
        const currentTime = new Date(current.statusDate || 0).getTime();
        if (candidateTime !== currentTime) {
            return candidateTime > currentTime;
        }
        return (candidate.id ?? 0) > (current.id ?? 0);
    }

    private resolveHistoryRowCategory(row: ISaleOrderStatusHistoryRow): SaleOrderStatusCategory | null {
        const nestedType = row.statusType?.statusType ?? (row as any).status_type?.status_type;
        if (nestedType != null) {
            return Number(nestedType) as SaleOrderStatusCategory;
        }

        const fromOptions = [...this.operationalStatusOptions, ...this.financialStatusOptions]
            .find((option) => option.empactStatusId === row.empactStatusId);

        return fromOptions?.statusType ?? null;
    }

    private mapStatusOptionsForSearch(options: IStatusType[]): IStatusType[] {
        return options.map((row) => ({
            ...row,
            name: this.deliveryStatusLabelPipe.transform(row.empactStatusId),
        }));
    }

    private findLatestStatusIdByCategory(
        histories: ISaleOrderStatusHistoryRow[],
        category: SaleOrderStatusCategory,
    ): number | null {
        return this.findLatestHistoryRowByCategory(histories, category)?.empactStatusId ?? null;
    }

    loadSaleOrderRemarks(): void {
        if (this.isCreateMode || !this.userSvc.isAdmin || !this.info?.id) {
            this.saleOrderRemarks = [];
            return;
        }

        this.remarksLoading = true;
        this.saleOrderSvc.getSaleOrderRemarks(this.info.id).subscribe(
            (rows) => {
                this.saleOrderRemarks = Array.isArray(rows) ? rows : (rows as any)?.data || [];
                this.remarksLoading = false;
            },
            (err) => {
                this.remarksLoading = false;
                this.saleOrderRemarks = [];
                this.notify.showError(err?.error?.error || err?.error?.message || 'Failed to load remarks');
            },
        );
    }

    onAddSaleOrderRemark(): void {
        if (!this.info?.id || !this.userSvc.isAdmin) {
            return;
        }

        const dialogRef = this.dialog.open(AddRemarkPopup, {
            width: '560px',
            maxWidth: '90vw',
        });
        dialogRef.componentInstance.remarkOptional = false;
        dialogRef.componentInstance.dialogTitle = 'Add remark';
        dialogRef.componentInstance.fieldLabel = 'Remark';
        dialogRef.componentInstance.useTextarea = true;

        dialogRef.afterClosed().subscribe((text) => {
            if (!text) {
                return;
            }

            this.showLoader = true;
            this.saleOrderSvc.addSaleOrderRemark(this.info.id, text).subscribe(
                () => {
                    this.showLoader = false;
                    this.notify.showSuccessMessage('Remark added successfully');
                    this.loadSaleOrderRemarks();
                },
                (err) => {
                    this.showLoader = false;
                    this.notify.showError(err?.error?.error || err?.error?.message || 'Failed to add remark');
                },
            );
        });
    }

    onDeleteSaleOrderRemark(remark: ISaleOrderRemark): void {
        if (!this.info?.id || !remark?.id || !this.userSvc.isAdmin) {
            return;
        }

        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = 'Are you sure you want to delete this remark?';
        dialogRef.componentInstance.rightBtnText = 'Delete';
        dialogRef.afterClosed().subscribe((confirmed) => {
            if (!confirmed) {
                return;
            }

            this.showLoader = true;
            this.saleOrderSvc.deleteSaleOrderRemark(this.info.id, remark.id).subscribe(
                () => {
                    this.showLoader = false;
                    this.notify.showSuccessMessage('Remark deleted successfully');
                    this.loadSaleOrderRemarks();
                },
                (err) => {
                    this.showLoader = false;
                    this.notify.showError(err?.error?.error || err?.error?.message || 'Failed to delete remark');
                },
            );
        });
    }

    getRemarkAuthorName(remark: ISaleOrderRemark): string {
        const user = remark?.user;
        if (!user) {
            return '';
        }
        if (user.contactName) {
            return user.contactName;
        }
        return `${user.firstName || ''} ${user.lastName || ''}`.trim();
    }

    subscribeShippingPhoneNumber() {
        this.form.get("shippingCountry").valueChanges.subscribe((value) => {
            if (value) {
                const country = this.countriesData?.find((c) =>
                    c.code === value
                );
                const code = country?.code.toLowerCase();
                const phonecode = country?.phoneCode.replace(/\+/g, '');

                this.form.get('phoneCountryCode').setValue(phonecode);
                this.form.get("phoneCountryCodeIso2").setValue(code);
                this.phoneObj.setCountry(this.form.get('phoneCountryCodeIso2').value);
            }
        });

        this.form.get("billingCountry").valueChanges.subscribe((value) => {
            if (value) {
                const country = this.countriesData?.find((c) =>
                    c.code === value
                );
                const code = country?.code.toLowerCase();
                const phonecode = country?.phoneCode.replace(/\+/g, '');
                this.form.get('buyerPhoneCountryCode').setValue(phonecode);
                this.form.get("buyerPhoneCountryCodeIso2").setValue(code);
                this.buyerPhoneObj.setCountry(this.form.get('buyerPhoneCountryCodeIso2').value);
            }
        });

    }

    async getAllCountries() {
        try {
            const data = await this.constSvc.getAvailableCountries(1, 1000).toPromise();
            if (data) {
                this.countriesData = data;
            }
            if (this.info?.marketplace?.buyer?.phoneCountryCode) {
                const country = this.countriesData?.find((c) =>
                    c.phoneCode === "+" + this.info?.marketplace?.buyer?.phoneCountryCode
                );

                this.form.get('phoneCountryCode').setValue(country?.code?.toLowerCase());
                this.form.get('phoneNumber').setValue(this.info?.marketplace?.buyer?.phoneNumber);
                this.phoneObj.setCountry(country?.code?.toLowerCase());
            }
            const apiBuyerPhoneCountry = this.info?.marketplace?.buyer?.buyerPhoneCountryCode;
            const buyerPhoneCountryMissing =
                apiBuyerPhoneCountry == null || String(apiBuyerPhoneCountry).trim() === '';
            if (!buyerPhoneCountryMissing) {
                const buyerCountry = this.countriesData?.find((c) =>
                    c.phoneCode === "+" + apiBuyerPhoneCountry
                );

                this.form.get('buyerPhoneCountryCode').setValue(buyerCountry?.code?.toLowerCase());
                this.form.get('buyerPhoneNumber').setValue(this.info?.marketplace?.buyer?.buyerPhoneNumber);
                this.buyerPhoneObj.setCountry(buyerCountry?.code?.toLowerCase());
            } else if (
                !this.isCreateMode &&
                !this.isMarketplaceSO &&
                this.form.get('billingCountry').value
            ) {
                const billingCountryValue = this.form.get('billingCountry').value;
                const countryFromBilling = this.countriesData?.find((c) => c.code === billingCountryValue);
                if (countryFromBilling?.code) {
                    const code = countryFromBilling.code.toLowerCase();
                    const phonecode = countryFromBilling.phoneCode.replace(/\+/g, '');
                    this.form.get('buyerPhoneCountryCode').setValue(phonecode);
                    this.form.get('buyerPhoneCountryCodeIso2').setValue(code);
                    this.form.get('buyerPhoneNumber').setValue(this.info?.marketplace?.buyer?.buyerPhoneNumber);
                    this.buyerPhoneObj?.setCountry(code);
                }
            }
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    }

    get isB2BCustomer() {
        return this.userSvc.user.role === Roles.OfflineShopOwner ? true : false;
    }

    private updateValidator(condition, name): void {
        if (condition) {
            this.form?.controls[name]?.setValidators(Validators.required);
            this.form?.controls[name]?.updateValueAndValidity();
        } else {
            this.form.controls[name]?.clearValidators();
            this.form.controls[name]?.updateValueAndValidity();
        }
    }

    private setOriginCountry(): void {
        if (this.allCountries) {
            const countryOfOriginCode = this.allCountries?.find((el) =>
                el?.code === this.info?.countryOfOriginCode ||
                el?.codeFull === this.info?.countryOfOriginCode
            );
            this.form.get('countryOfOriginCode').setValue(countryOfOriginCode?.codeFull);
        } else {
            this.form.get('countryOfOriginCode').setValue(this.info?.countryOfOriginCode);
        }
        this.form.controls.countryOfOriginCode.valueChanges.subscribe(value => {
            this.selectedOriginCountry.emit(this.allCountries.find(el =>
                el?.codeFull === value || el?.code === value
            ));
        })
    }

    subscribeOnAvailableMarketplaces(companyId): void {
        if (!companyId) {
            return;
        }
        this.companyMarketplaceSvc.getListOfMarketplaces(1, 100, companyId).subscribe(data => {
            this.marketplaceList = data?.items;
            // TO DO
            if (!this.isCreateMode) {
                this.form.controls.marketplaceName.setValue(this.info?.marketplace?.name.toString());
            } else {
                this.form.controls.marketplaceName.setValue(data?.items?.length ? data?.items[0].id : undefined);
            }
            this.updateCountryOfOriginCodeByMarketplace(data);
        });
    }

    private updateCountryOfOriginCodeByMarketplace(data: any): void {
        const marketplaceName = this.form.get('marketplaceName').value;
        const marketplace = data?.items.find((item) => item.id === marketplaceName);
        if (!this.info.countryOfOriginCode && marketplace && this.allCountries?.length > 0) {
            const originCountry = this.allCountries.find((c) => c.id === marketplace?.sourceCountryId);
            this.form.get('countryOfOriginCode').setValue(originCountry?.codeFull);
        }
    }

    initializeForm(info: ISaleOrder): FormGroup {
        if (this.isCreateMode) {
            this.InputType = 'locale-date';
        } else {
            this.InputType = 'text';
        }
        this.currentOrderStatus = SaleOrderStatus[info?.status];
        this.orderCurrency = this.isCreateMode ? info?.currency : (info?.currency || 'Currency N/D');
        this.getCitiesByCountryId(info?.marketplace?.buyer?.billingAddress?.state?.country?.id, true);
        this.getCitiesByCountryId(info?.marketplace?.buyer?.shippingAddress?.state?.country?.id, false);
        !this.isCreateMode && this.buyerName.disable();

        const amountDisplay = this.resolveAmountDisplayValues(info);

        return this.formBuilder.group({
            orderID: [{ disabled: !this.isCreateMode, value: info?.orderId || '' }],
            // orderDate: [{ disabled: !this.isCreateMode, value: info?.orderDate ? this.datePipe.transform(info?.orderDate,'dd/MM/yyyy') : null }],
            orderDate: [{ disabled: false, value: info?.orderDate ? new Date(info?.orderDate) : new Date() }, [Validators.required]],
            customerID: [{ disabled: true, value: (this.userSvc.isAdmin ? info?.company?.companyCode : this.userSvc.userStorage.company.companyCode) || '' }],
            sellerName: [{
                disabled: !this.isCreateMode,
                value: (this.userSvc.isAdmin ?
                    this.isCreateMode ? info?.companyId : info?.company?.name :
                    this.userSvc.userStorage.company.name)
            },
            info?.isEmpact ? null : [Validators.required]],
            marketPlaceVat: [{ disabled: !this.isCreateMode, value: (info?.marketplace?.vatCharges || 0)?.toFixed(2) }, !this.isB2BSaleOrder ? [Validators.required] : ''],
            // discount: [{ disabled: !this.isCreateMode, value: (parseFloat(info?.discountPercentage?.toString()) || 0) }], // deplrecate discount field
            marketplaceWebhookAmount: [{ disabled: this.isCreateMode || !this.userSvc.isAdmin, value: info?.marketplaceWebhookAmount || 0 }, []],
            marketplaceWebhookRefundAmount: [{ disabled: this.isCreateMode || !this.userSvc.isAdmin, value: info?.marketplaceWebhookRefundAmount || 0 }, []],
            shipmentDescr: [{ disabled: !this.isCreateMode, value: info?.shipmentDescription || '' }, [/*Validators.required*/]],
            marketplaceOrderID: [{ disabled: false, value: info?.marketplace?.marketplaceOrderId || '' }, [Validators.required]],
            marketplaceName: [{ disabled: !this.isCreateMode || (this.info?.isDraft && this.isMarketplaceSO), value: info?.marketplace?.saleOrderMarketplace?.id || null }, [Validators.required]],
            marketplaceSellerName: [{
                disabled: !this.isCreateMode,
                value: info?.marketplace?.sellerName
            }, [Validators.required]],
            invoiceNumber: [{ disabled: !this.isCreateMode, value: info?.marketplace?.invoiceNumber || '' }, [Validators.required]],
            buyerID: [{ disabled: !this.isCreateMode, value: info?.marketplace?.buyer?.buyerId || '' }, info?.isEmpact || this.isMarketplaceSO ? [] : [Validators.required]],
            buyerName: [{ disabled: !this.isCreateMode, value: info?.marketplace?.buyer?.name || '' }, [Validators.required]],
            currency: [{ disabled: !this.canAdminEditCurrency, value: info?.currency }, [Validators.required]],
            buyerType: [{ disabled: !this.isCreateMode, value: info?.buyerType }, [Validators.required]],
            isB2B: [{ disabled: !(this.userSvc.isIndVat || this.userSvc.isAdmin), value: info?.isB2B }],
            vatNumber: [{ disabled: !this.isCreateMode, value: info?.vatNumber }, [Validators.pattern('^[0-9a-zA-Z]{8,15}$')]],
            billingName: [{ disabled: !this.isCreateMode, value: info?.marketplace?.buyer?.billingName || '' }, [Validators.required]],
            billingAddrees: [{ disabled: !this.isCreateMode, value: info?.marketplace?.buyer?.billingAddress?.name || '' }, [Validators.required]],
            billingCountry: [{ disabled: !this.isCreateMode, value: info?.marketplace?.buyer?.billingAddress?.state?.country?.code || null }, [Validators.required]],
            billingState: [{ disabled: !this.isCreateMode, value: info?.marketplace?.buyer?.billingAddress?.state?.stateId || null }, [Validators.required]],
            billingCity: [{ disabled: !this.isCreateMode && !this.userSvc.isAdmin, value: this.removeDiacritics(info?.marketplace?.buyer?.billingAddress?.city) || '' }, [Validators.required]],
            billingZipCode: [{ disabled: !this.isCreateMode, value: info?.marketplace?.buyer?.billingAddress?.zipCode || '' }, [Validators.required, Validators.minLength(formConstant.minZipCodeLength)]],
            shippingAddrees: [{ disabled: (!this.isCreateMode && !this.userSvc.isAdmin), value: info?.marketplace?.buyer?.shippingAddress?.name || '' }, [Validators.required]],
            shippingCountry: [{ disabled: (!this.isCreateMode && !this.userSvc.isAdmin), value: info?.marketplace?.buyer?.shippingAddress?.state?.country?.code || null }, [Validators.required]],
            shippingState: [{ disabled: (!this.isCreateMode && !this.userSvc.isAdmin), value: info?.marketplace?.buyer?.shippingAddress?.state?.stateId || null }, [Validators.required]],
            shippingCity: [{ disabled: (!this.isCreateMode && !this.userSvc.isAdmin), value: this.removeDiacritics(info?.marketplace?.buyer?.shippingAddress?.city) || '' }, [Validators.required]],
            shippingZipCode: [{ disabled: (!this.isCreateMode && !this.userSvc.isAdmin), value: info?.marketplace?.buyer?.shippingAddress?.zipCode || '' }, [Validators.required, Validators.minLength(formConstant.minZipCodeLength)]],
            shipmentTrackingNumber: [{ disabled: false, value: info?.shipmentTrackingNumber || '' }],
            carrierCompany: [{ disabled: false, value: info?.carrierCompany || '' }],
            shippingDate: [{ disabled: false, value: info?.shipmentDate ? new Date(info?.shipmentDate) : new Date() }],
            countryOfOriginCode: [{ disabled: false, value: info?.countryOfOriginCode }],
            deliveryDate: [{ disabled: false, value: info?.deliveryDate ? new Date(info?.deliveryDate) : null }],
            referenceOrderId: [{ disabled: true, value: info?.marketplace?.referenceOrderId }],
            conversionRate: [{ disabled: true, value: info?.conversionRate }],
            eciVatEuro: [{ disabled: true, value: amountDisplay.eciVatEuro }],
            eciTotalEuro: [{ disabled: true, value: amountDisplay.eciTotalEuro }],
            shipmentCost: [{ disabled: !this.isCreateMode, value: ((info?.shipmentCost || 0) + (info?.shipmentVat || 0))?.toFixed(2) }],
            sellOrderTotal: [{ disabled: true, value: amountDisplay.sellOrderTotal }, [Validators.required]],
            eciVat: [{ disabled: !this.isCreateMode, value: amountDisplay.eciVat }],
            theoreticalVat: [{ disabled: !this.isCreateMode, value: amountDisplay.theoreticalVat }],
            sellOrderAmount: [{ disabled: !this.isCreateMode, value: amountDisplay.sellOrderAmount }],
            email: [{ disabled: !this.isCreateMode, value: info?.marketplace?.buyer?.email || '' }],
            phoneNumber: [{ disabled: (!this.isCreateMode && !this.userSvc.isAdmin), value: info?.marketplace?.buyer?.phoneNumber || '' }, []],
            phoneCountryCode: [{ disabled: (!this.isCreateMode && !this.userSvc.isAdmin), value: info?.marketplace?.buyer?.phoneCountryCode || '1' }],
            phoneCountryCodeIso2: [info?.marketplace?.buyer?.shippingAddress?.state?.country?.code],
            buyerPhoneCountryCodeIso2: [info?.marketplace?.buyer?.billingAddress?.state?.country?.code],
            buyerEmail: [{ disabled: !this.isCreateMode, value: info?.marketplace?.buyer?.buyerEmail || '' },
            info?.isEmpact || this.isMarketplaceSO ? [emailValidator()] : []],
            buyerPhoneNumber: [{ disabled: (!this.isCreateMode && !this.userSvc.isAdmin), value: info?.marketplace?.buyer?.buyerPhoneNumber || '' }, [cellPhoneValidatorNew()]],
            buyerPhoneCountryCode: [{ disabled: (!this.isCreateMode && !this.userSvc.isAdmin), value: info?.marketplace?.buyer?.buyerPhoneCountryCode || '1' }],
            orderStatuss: [{
                disabled: this.userSvc.isDelicated,
                value: SaleOrderStatus[info?.status] || ''
            }],
            operationalStatus: [{ disabled: !this.userSvc.isAdmin || this.userSvc.isDelicated, value: null }],
            financialStatus: [{ disabled: !this.userSvc.isAdmin || this.userSvc.isDelicated, value: null }],
        });
    }

    isB2b() {
        if (this.isCreateMode) {
            this.form.get('isB2B').setValue(this.isB2BSaleOrder);
        }
    }

    get model(): ISaleOrder {
        const selectedMarketplace = this.marketplaceList?.find(
            (el) => Number(el.id) === Number(this.form.get('marketplaceName').value)
        );
        return {
            ...this.info,
            orderId: this.form.get('orderID').value || null,
            orderDate: this.form.get('orderDate').value != "Invalid Date" ? this.datePipe.transform(this.form.get('orderDate').value, 'yyyy-MM-dd') : '',
            companyId: this.userSvc.isAdmin ? parseInt(this.form.get('sellerName').value) : parseInt(this.userSvc.userStorage.company.id),
            shipmentCost: parseFloat(this.form.get('shipmentCost').value) || 0,
            total: parseFloat(this.form.get('sellOrderTotal').value) || null,
            marketplaceWebhookAmount: this.form.get('marketplaceWebhookAmount').value || 0,
            marketplaceWebhookRefundAmount: this.form.get('marketplaceWebhookRefundAmount').value || 0,
            shipmentDescription: this.form.get('shipmentDescr').value || null,
            eciVat: Number(this.form.get('eciVat').value),
            // discountPercentage: this.form.get('discount').value || 0, // deplrecate discount field
            buyerType: this.form.get('buyerType').value,
            isB2B: this.form.get('isB2B').value,
            vatNumber: this.form.get('vatNumber').value || '',
            carrierCompany: this.form.get('carrierCompany').value || '',
            shipmentTrackingNumber: this.form.get('shipmentTrackingNumber').value || '',
            shipmentDate: this.form.get('shippingDate').value != "Invalid Date" ? this.datePipe.transform(this.form.get('shippingDate').value, 'yyyy-MM-dd') : '',
            deliveryDate: this.form.get('shippingDate').value != "Invalid Date" ? this.datePipe.transform(this.form.get('deliveryDate').value, 'yyyy-MM-dd') : '',
            currency: this.form.get('currency').value, // HARD CODED FOR NOW - IN THE FUTURE COULD BE CHANGE TO ONE OF THE LIST
            marketplace: {
                vatCharges: parseFloat(this.form.get('marketPlaceVat').value) || 0,
                marketplaceOrderId: this.form.get('marketplaceOrderID').value || null,
                name: parseInt(this.form.get('marketplaceName').value) || null,
                sellerName: this.form.get('marketplaceSellerName').value || null,
                invoiceNumber: this.form.get('invoiceNumber').value || null,
                buyer: {
                    buyerId: this.form.get('buyerID').value || null,
                    name: this.form.get('buyerName').value || null,
                    email: this.form.get('email').value || null,
                    buyerEmail: this.form.get('buyerEmail').value || null,
                    phoneNumber: this.form.get('phoneNumber').value || null,
                    buyerPhoneNumber: this.form.get('buyerPhoneNumber').value || null,
                    phoneCountryCode: this.form.get('phoneCountryCode').value || null,
                    buyerPhoneCountryCode: this.form.get('buyerPhoneCountryCode').value || null,
                    billingName: this.form.get('billingName').value || null,
                    billingAddress: {
                        name: this.form.get('billingAddrees').value || null,
                        stateId: this.form.get('billingState').value || null,
                        city: this.form.get('billingCity').value || null,
                        zipCode: this.form.get('billingZipCode').value || null,
                    },
                    shippingAddress: {
                        name: this.form.get('shippingAddrees').value || null,
                        stateId: this.form.get('shippingState').value || null,
                        city: this.form.get('shippingCity').value || null,
                        zipCode: this.form.get('shippingZipCode').value || null,
                        countryId: this.allCountries?.find(el => el.code === this.form.get('shippingCountry').value)?.id || null,
                    }
                }
            },
            disableB2BShipment: this.disableB2BShipment,
            countryOfOriginCode: this.form.get('countryOfOriginCode').value,
            shopId: selectedMarketplace?.shopId || this.info?.shopId,
            shopName: selectedMarketplace?.shopName || this.info?.shopName,
            paymentTerms: this.selectedBuyer?.paymentsTerms,
        }
    }

    isDatePickerValid(item: string): boolean {
        if (!item) return;
        const el = this.form?.get(item);
        return (el && el.value !== null);
    }

    subscribeOnAvailaableTypes(): void {
        this.constSvc.availableCountries.subscribe((data) => {
            if (data) {
                this.allCountries = data;
                this.setOriginCountry();
            }
        });

        this.valueChangesSubscribe('billingCountry', 'billingState');
        this.valueChangesSubscribe('shippingCountry', 'shippingState');
    }

    public onChangeOriginCountry(country): void {
        this.form.get('countryOfOriginCode').setValue(country?.codeFull);
    }

    private valueChangesSubscribe(controlToSubscribe: string, controlName: string): void {
        this.form.get(controlToSubscribe).valueChanges
            .subscribe((value) => {
                if (value) {
                    this.updateState(controlName, value);
                }
            });
    }

    private updateState(elementName: string, value: number | string): void {
        const selectedCountry = this.allCountries?.find((el) => el.code === value);
        this.getCitiesByCountryId(selectedCountry?.id, elementName === 'billingState');
        this.constSvc.getAvailableStatesById(value).subscribe((states) => {
            if (this.shouldUpdateState) {
                if (!states) {
                    return;
                }
                this[`${elementName}s`] = states;
                if (!states) {
                    this.form.get(elementName).setValue(null);
                    return;
                }

                let st = null;
                if (elementName === 'billingState') {
                    const stateId = this.info?.marketplace?.buyer?.billingAddress?.stateId ?
                        this.info?.marketplace?.buyer?.billingAddress?.stateId : this.selectedBuyer?.address?.stateId;

                    st = this[`${elementName}s`].find(
                        (el) => el.id == stateId
                    );

                } else {
                    st = this[`${elementName}s`].find(
                        (el) => el.id == this.info?.marketplace?.buyer?.shippingAddress?.stateId
                    );
                }
                this.form.get(elementName).setValue(st ? st.id : states && states[0]?.id || null);
            } else {
                this.shouldUpdateState = true;
            }
        });
    }

    // getCompanyList(limit?, page?): void {
    //     const methodName: string = this.isMarketplaceSO ? 'getEcommerceCompanyList' : 'getCompanyList';
    //     this.regSvc[methodName]('', limit, page).subscribe(data => {
    //         data.items = data.items.filter(details => details.name.length > 0);
    //         data.items.forEach(element => {
    //             this.companyList.push(element);
    //         });
    //     });
    // }
    getCompanyList(limit?, page?): void {
        const methodName: string = this.isMarketplaceSO ? 'getEcommerceCompanyList' : 'getCompanyListForSales';
        this.regSvc[methodName]('', limit, page).subscribe(data => {
            if (methodName == 'getCompanyListForSales') {
                data = data.filter(details => details.name.length > 0);
                data.forEach(element => {
                    this.companyList.push(element);
                });
            } else {
                data.items = data.items.filter(details => details.name.length > 0);
                data.items.forEach(element => {
                    this.companyList.push(element);
                });
            }
        });
    }

    clearSearchValue(): void {
        this.searchCustomerName.setValue('');
        this.searchCountry.setValue('');
        this.searchState.setValue('');
        this.searchShipmentCountry.setValue('');
        this.searchShipmentState.setValue('');
        this.searchCustomerName.setValue('');
        this.searchmarketplaceName.setValue('');
        this.searchbuyerType.setValue('');
        this.searchShipmentCity.setValue('');
        this.searchBillingCity.setValue('');
        this.searchOriginCountry.setValue('');
        this.searchOperationalStatus.setValue('');
        this.searchFinancialStatus.setValue('');
    }

    subscribeOnFieldChanges(): void {
        this.form.get('sellerName').valueChanges.subscribe(value => {
            const elem = this.companyList.find(el => el.id == value);
            if (!elem) return;
            this.form.get('customerID').setValue(elem.companyCode);
            if (elem?.users && elem?.users[0]?.partner === 'JD') {
                this.shippingPhoneNumberRequired = true;
                this.form.get('phoneNumber').setValidators([cellPhoneValidatorNew()]);
            } else {
                this.shippingPhoneNumberRequired = false;
                this.form.get('phoneNumber').setValidators([]);
            }
            if (this.isMarketplaceSO) {
                this.form.get('marketplaceSellerName').setValue(elem.name);
            }
        })
    }

    changeTo0(field: string): void {
        this.form.get(field).value < 0 ? this.form.get(field).setValue(0) : '';
    }

    checkMin(): boolean {
        return this.form?.get('marketPlaceVat')?.value >= this.form?.get('sellOrderTotal')?.value || this.form?.get('marketPlaceVat')?.value <= 0;
    }

    updateOrderstatus(newOrderStatus: any): void {
        if (newOrderStatus == 'REORDER') {
            this.reorder();
        } else {
            const dialogRef = this.dialog.open(ConfirmPopupDialog);
            dialogRef.componentInstance.message = `Please confirm changing status to ${newOrderStatus}`;
            dialogRef.afterClosed().subscribe(value => {
                this.showLoader = true;
                if (!value) {
                    this.showLoader = false;
                    return;
                }
                let dialogReff = this.dialog.open(AddRemarkPopup);
                dialogReff.afterClosed().subscribe(val => {
                    if (!val) {
                        this.showLoader = false;
                        return;
                    }
                    this.saleOrderSvc.updateOrder(this.info.id, { 'event': newOrderStatus, 'remark': val }).subscribe(data => {
                        this.notify.showSuccessMessage('Order state updated successfully');
                        this.currentOrderStatus = newOrderStatus;
                        this.getOrder.emit(this.info.id);
                        this.showLoader = false;
                        this.isStatusRemark = val;
                        if (isDeliveredSaleOrderStatusName(newOrderStatus)) {
                            let date = this.info?.deliveryDate && this.info?.deliveryDate != null ? new Date(this.info?.deliveryDate) : new Date();
                            this.form.controls.deliveryDate.setValue(date);
                        }
                        this.form.controls.orderStatuss.setValue(newOrderStatus);
                    });
                });

            });
        }

    }

    get checkWixMarketPlaceVAT(): boolean {
        const selectedMarketPlace = this.info?.marketplace?.saleOrderMarketplace?.marketplaceInfo?.name || '';
        const vatCharges = Number(this.info?.marketplace?.vatCharges || 0);
        if (this.isCreateMode || selectedMarketPlace !== 'wix') {
            return true;
        }
        return vatCharges !== 0.1;
    }

    hideStatus(status): boolean {
        return !this.userSvc.isAdmin &&
            !this.userSvc.isDelegatedAdmin &&
            status !== 'CANCELED';
    }

    get canAdminEditCurrency(): boolean {
        if (this.isCreateMode) {
            return true;
        }
        if (!this.userSvc.isAdmin) {
            return false;
        }
        return !this.isCurrencyLockedByStatus();
    }

    private isCanceledSaleOrderStatus(status: number | null | undefined): boolean {
        return status === SaleOrderStatus.CANCELED
            || status === SaleOrderStatus.SHIPMENT_CANCELED
            || status === SaleOrderStatus.EARLY_CANCELATION;
    }

    private isCurrencyLockedByStatus(): boolean {
        const operational = this.currentOperationalStatusId ?? this.info?.latestOperationalStatusId ?? this.info?.status;
        const financial = this.currentFinancialStatusId ?? this.info?.latestFinancialStatusId;
        if (isDeliveredSaleOrderStatus(operational)) {
            return true;
        }
        if (this.isCanceledSaleOrderStatus(operational) || this.isCanceledSaleOrderStatus(this.info?.status)) {
            return true;
        }
        if (financial === SaleOrderStatus.FULL_REFUND || isFullFinancialRefundOrder(this.info)) {
            return true;
        }
        return false;
    }

    private syncCurrencyEditability(): void {
        const control = this.form?.get('currency');
        if (!control) {
            return;
        }
        if (this.canAdminEditCurrency) {
            control.enable({ emitEvent: false });
        } else {
            control.disable({ emitEvent: false });
        }
    }

    updateStripeAmount(): void {
        this.saleOrderSvc.updateOrderStripeAmount(this.info?.id, {
            amount: this.form.controls.sellOrderMarketplaceWebhookAmount.value,
        }).subscribe(() => {
            this.notify.showSuccessMessage('Sale Order updated successfully');
        }, err => {
            this.notify.showSuccessMessage('Something went wrong');
        });
    }

    getCitiesByCountryId(countryID: string | number, isBillingCities: any): void {
        if (!countryID) {
            return;
        }
        this.citySvc.getAllByCountryId(countryID).subscribe(cities => {
            if (!cities) {
                return;
            }

            if (isBillingCities) {
                this.billingCities = cities;
                // if (this.selectedBuyer) {
                //     let st = this.billingCities.find(el => el.id === this.selectedBuyer.address?.city || el.city === this.selectedBuyer.address?.city );
                //     this.form.get('billingCity').setValue(st?.city || null);
                // }
            } else {
                this.shippingCities = cities;
            }
        });
    }

    update(): void {
        let body = this.bodyToUpdate;
        // debugger;
        this.saleOrderSvc.updateOrderValue(this.info.id, body).subscribe(value => {
            this.getOrder.emit(this.info.id);
            this.notify.showSuccessMessage('Sale Order update successfully');
        }, err => {
            this.getOrder.emit(this.info.id);
            if (err?.error?.message) {
                this.notify.showError(err?.error?.message);
            } else {
                this.notify.showError('Something went wrong');
            }
        });
    }

    get bodyToUpdate(): any {
        this.info = {
            ...this.info,
            ...this.form.value,
            vatNumber: this.form.get('vatNumber').value || '',
            currency: this.form.get('currency').value || '',
            marketplace: {
                ...this.info.marketplace,
                marketplaceOrderId: this.form.get('marketplaceOrderID').value,
                buyer: {
                    ...this.info.marketplace.buyer,
                    id: this.info.marketplace.buyer.id,
                    shippingAddress: {
                        ...this.info.marketplace.buyer.shippingAddress,
                        type: this.info.marketplace.buyer.shippingAddress?.type || 'ShippingAddress',
                        name: this.form.get('shippingAddrees').value || '',
                        stateId: this.form.get('shippingState').value || null,
                        city: this.form.get('shippingCity').value || null,
                        zipCode: this.form.get('shippingZipCode').value || null,
                        countryId: this.allCountries?.find(el => el.code === this.form.get('shippingCountry').value)?.id || null,
                    },
                    billingAddress: {
                        ...this.info.marketplace.buyer.billingAddress,
                        type: this.info.marketplace.buyer.billingAddress?.type || 'BillingAddress',
                        city: this.form.get('billingCity').value || null,
                    },
                    phoneNumber: this.form.hasError('incorrect', 'phoneNumber') ? (this.info.marketplace.buyer?.phoneNumber || null) : (this.form.get('phoneNumber').value || null),
                    phoneCountryCode: this.form.hasError('incorrect', 'phoneNumber') ? (this.info.marketplace.buyer?.phoneCountryCode || null) : (this.form.get('phoneCountryCode').value || null),
                    buyerPhoneNumber: this.form.hasError('incorrect', 'buyerPhoneNumber') ? (this.info.marketplace.buyer?.buyerPhoneNumber || null) : (this.form.get('buyerPhoneNumber').value || null),
                    buyerPhoneCountryCode: this.form.hasError('incorrect', 'buyerPhoneCountryCode') ? (this.info.marketplace.buyer?.buyerPhoneCountryCode || null) : (this.form.get('buyerPhoneCountryCode').value || null),
                }
            },
            shipmentDate: this.form.get('shippingDate').value != 'Invalid Date' ? this.datePipe.transform(this.form.get('shippingDate').value, 'yyyy-MM-dd HH:mm:ss') : '',
            deliveryDate: this.form.get('deliveryDate').value != 'Invalid Date' ? this.datePipe.transform(this.form.get('deliveryDate').value, 'yyyy-MM-dd HH:mm:ss') : '',
            orderDate: this.form.get('orderDate').value != 'Invalid Date' ? this.datePipe.transform(this.form.get('orderDate').value, 'yyyy-MM-dd HH:mm:ss') : '',
        };
        return this.info;
    }

    reorder(): void {
        this.clickReorder.emit();
    }

    private showSumEciAndShipmentVat(saleOrder: ISaleOrder): boolean {
        if (!saleOrder) {
            return false;
        }

        if (saleOrder.currency === 'EUR' && saleOrder.marketplace?.buyer?.shippingAddress?.state?.country?.isEurope &&
            saleOrder.marketplace?.buyer?.shippingAddress?.state?.country?.code !== 'GB') {
            return true;
        }

        if (saleOrder.currency === 'GBP' &&
            saleOrder.marketplace?.buyer?.shippingAddress?.state?.country?.code === 'GB') {
            return true;
        }

        return false;
    }

    currencyToConvert(saleOrder: ISaleOrder): string {
        if (!saleOrder) {
            return '';
        }

        if (saleOrder.marketplace?.buyer?.shippingAddress?.state?.country?.code === 'GB') {
            return 'GBP';
        }

        return 'EUR';
    }

    resync(): void {
        let body = this.bodyToUpdate;
        this.saleOrderSvc.resyncOrderValue(this.info.id, body).subscribe(value => {
            this.getOrder.emit(this.info.id);
            this.notify.showSuccessMessage('Sale Order update successfully');
        }, err => {
            this.getOrder.emit(this.info.id);
            this.notify.showSuccessMessage('Something went wrong');
        });
    }

    clearDeliveryDate(): void {
        this.form.controls.deliveryDate.setValue(null);
    }

    // Calculate eciTotal by adding poducts only for new SO
    private checkEciTotal(change: SimpleChange): void {
        if (this.info?.eciTotal) {
            this.form.controls.sellOrderTotal.setValue(this.info?.eciTotal + this.info?.shipmentCost);
            //this.form.controls.sellOrderTotal.setValue(this.info?.eciTotal);
            return;
        }
        if (change.currentValue?.products?.length !== change.previousValue?.products?.length) {
            const eciTotal = this.info.products?.reduce((sum, p) => sum + (+p.total || (p.price * p.units)), 0);
            this.form.controls.sellOrderTotal.setValue(eciTotal + this.info?.shipmentCost);

            //this.form.controls.sellOrderTotal.setValue(eciTotal);
        }
    }

    public confirmDialog(): void {
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = `Need to update tracking number and carrier company.`;
        dialogRef.componentInstance.leftBtnText = 'Ok';
        dialogRef.componentInstance.header = 'Notification';
        dialogRef.componentInstance.showRightBtn = false;
    }

    addNewCity(cityType: CityType, countryCode: string): void {
        if (!countryCode) {
            return;
        }
        let countryId = this.allCountries.find(el => el.code === countryCode).id;
        let dialogRef = this.dialog.open(AddCityPopup);

        dialogRef.afterClosed().subscribe(val => {
            if (!val) {
                return undefined;
            }

            this.citySvc.create(countryId, val).subscribe(res => {
                this.notify.showSuccessMessage('City created successfully');

                if (cityType === CityType.Shipping) {
                    this.form.controls.billingCity.setValue(val);
                }

                if (cityType === CityType.Billing) {
                    this.form.controls.shippingCity.setValue(val);
                }

                this.getCitiesByCountryId(countryId, cityType === CityType.Billing);
            }, (e) => {
                if (!e?.error) {
                    return;
                }
                switch (e.error.message) {
                    case 'CITY.ERRORS.ALREADY_EXIST':
                        this.notify.showError('City Already Exist');
                        break;
                    case 'COUNTRY.ERRORS.NOT_FOUND':
                        this.notify.showError('Country not found');
                        break;
                    default:
                        this.notify.showError(e.error.message);
                }
            });
        });
    }

    get savedCarrierNotInList(): string {
        const savedCarrier = this.form?.get('carrierCompany')?.value;
        if (!savedCarrier || this.availableCarriers.some((carrier) => carrier.name === savedCarrier)) {
            return '';
        }
        return savedCarrier;
    }

    getAvailableCarriers(
        q: string = this.searchCarrier.value,
        page: number = this.previousCarriersPage + 1,
        limit: number = 2500,
    ) {
        this.carriersSvc.get<IPaginatorProperties<ICarrierItem>>('carriers', page, limit, q).subscribe(data => {
            if (!data) {
                return;
            }
            this.availableCarriers = [...data.items];
            this.previousCarriersPage = data.meta.currentPage;
            this.totalCarriersPage = data.meta.totalPages;
        });
    }

    onFillData() {
        //   if (this.form.get('buyerName').value) {
        this.shouldUpdateState = false;
        this.shippingCities = this.billingCities;
        this.shippingStates = this.billingStates;
        this.form.get('shippingCountry').setValue(this.form.get('billingCountry').value);
        this.form.get('shippingState').setValue(this.form.get('billingState').value);
        this.form.get('shippingCity').setValue(this.form.get('billingCity').value);
        this.form.get('shippingAddrees').setValue(this.form.get('billingAddrees').value);
        this.form.get('shippingZipCode').setValue(this.form.get('billingZipCode').value);
        this.form.get('email').setValue(this.form.get('buyerEmail').value);
        this.form.get('phoneNumber').setValue(this.form.get('buyerPhoneNumber').value);
        this.form.get('phoneCountryCode').setValue(this.form.get('buyerPhoneCountryCode').value);
        this.form.get('phoneCountryCodeIso2').setValue(this.form.get('buyerPhoneCountryCodeIso2').value);
        this.phoneObj.setCountry(this.form.get('buyerPhoneCountryCodeIso2').value);
        //    }
    }

    /*
        onAddNewBuyer(buyerNameSelect: MatSelect) {
            buyerNameSelect.close();
            const newBuyer = {
                fullName: this.newBuyerName.value
            }
            this.buyers.push(newBuyer);
            this.buyerName.setValue(newBuyer);

            this.form.get('vatNumber').setValue('');
            this.form.get('billingAddrees').setValue('');
            this.form.get('billingZipCode').setValue('');
            this.form.get('billingCountry').setValue('');
            this.form.get('billingState').setValue('');
            this.form.get('billingCity').setValue('');
            this.form.get('buyerEmail').setValue('');
            this.form.get('buyerPhoneNumber').setValue('');

        }

        handleNewBuyer(e: KeyboardEvent) {
            if (e.code === 'Space') {
                e.stopPropagation();
            }
        }
    */

    public openAddProductPopup(): void {
        const customerID = this.userSvc.isAdmin ? this.form.get('sellerName').value : this.userSvc.userStorage.company.id;
        if (isNaN(+customerID)) {
            this.notify.showWarn('Please choose customer first');
            return;
        }

        const dialogRef = this.dialog.open(B2bclientsAccessPopupComponent, {});
        dialogRef.componentInstance.title = 'Add B2B Clients';
        dialogRef.componentInstance.customerId = Number(customerID);
        dialogRef.componentInstance.countries = this.allCountries;
        dialogRef.afterClosed().subscribe((result) => {
            this.getAvailableBuyers(customerID);
            if (!result) {
                return;
            }
        });
    }

    getAvailableBuyers(id): void {
        this.b2bclientsService.getBuyers(id).subscribe(res => {
            this.buyers = res || [];
            if (this.info?.marketplace?.buyer?.name) {
                const buyer = this.buyers.find(b => b.email === this.info?.marketplace?.buyer?.email);
                if (!buyer) {
                    const newBuyer = {
                        firstName: this.info?.marketplace?.buyer?.name || ''
                    }
                    this.buyers.push(newBuyer);
                    this.buyerName.setValue(newBuyer);
                } else {
                    this.buyerName.setValue(buyer);
                }
            }
        })
    }

    public getCityName(city: any): string {
        return `${city?.city} ${city?.zipCode ? `(${city?.zipCode})` : ''}`;
    }

    public hasErrors(error, field): void {
        if (!error && this.shippingPhoneNumberRequired) {
            this.form.controls[field].setErrors({ 'incorrect': !error });
        } else {
            this.form.controls[field].setErrors(null);
        }
    }

    public getNumber(e, field, phoneCode): void {
        const value = e.replace(`+${this.form?.controls[phoneCode]?.value}`, '');
        this.form.controls[field].setValue(value);
    }

    public onCountryChange(countryPhoneCode, codeField): void {
        this.form?.controls[`${codeField}Iso2`]?.setValue(countryPhoneCode.iso2);
        this.form?.controls[codeField]?.setValue(countryPhoneCode.dialCode);
    }

    private getBillingCountryIso2Lower(): string | null {
        const value = this.form?.get('billingCountry')?.value;
        const s = value != null ? String(value).trim() : '';
        return s ? s.toLowerCase() : null;
    }

    private getIso2Code(phoneCode): string {
        if (this.allCountries?.length === 0 || !phoneCode) {
            return 'us';
        }
        const country = this.allCountries?.find((c) => c.phoneCode === phoneCode);
        return country?.code.toLowerCase();
    }

    public telInputObject(event, name): void {
        this[name] = event;
    }

    public calculateSOGrandTotal(event: any){
        const shipmentCost = Number(event.target.value);
        //const eciTotal = this.info?.eciTotal || 0;
        //this.form.controls.sellOrderTotal.setValue(eciTotal + shipmentCost);
        if (this.info?.eciTotal) {
            const eciTotal = this.info?.eciTotal || 0;
            this.form.controls.sellOrderTotal.setValue(eciTotal + shipmentCost);
            return;
        } else {
            const eciTotal = this.info.products?.reduce((sum, p) => sum + (p.price * p.units), 0);
            this.form.controls.sellOrderTotal.setValue(eciTotal + shipmentCost);
        }
    }

    public calculateSOTotalAmountIncVAT(event: any){
        const shipmentCost = Number(event.target.value);
        let totalAmount = 0;
        if (this.info?.products && this.info?.products.length > 0) {
            totalAmount = this.info.products?.reduce((sum, p) => sum + (+p.total || (p.price * p.units)), 0);
        } else if (this.info?.eciTotal) {
            totalAmount = this.info?.eciTotal;
        }

        this.form.controls.sellOrderTotal.setValue(shipmentCost + totalAmount);
    }

    public removeDiacritics(str: string): string {
        if (!str) return str;
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
    }

    compareCity = (a: string, b: string): boolean => {
        if (!a || !b) return a === b;

        return a.toLowerCase() === b.toLowerCase();
    };
}
